import React from 'react'
import styled from 'styled-components'
import { FinanceMetricTone } from '../types'

interface Props {
  label: React.ReactNode
  value: React.ReactNode
  tone?: FinanceMetricTone
  subtext?: React.ReactNode
}

const backgrounds = {
  default: 'linear-gradient(180deg, #eff6ff 0%, #fafcff 100%)',
  success: 'linear-gradient(180deg, #ecfdf5 0%, #f8fffb 100%)',
  warning: 'linear-gradient(180deg, #fffbeb 0%, #fffdf7 100%)',
  danger: 'linear-gradient(180deg, #fff1f2 0%, #fff8f8 100%)',
} as const

const Card = styled.div<{ $tone: FinanceMetricTone }>`
  background: ${(props) => backgrounds[props.$tone]};
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 18px;
`

const Label = styled.div`
  color: #6b7280;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
`

const Value = styled.div`
  color: #111827;
  font-size: 24px;
  font-weight: 700;
`

const Subtext = styled.div`
  margin-top: 6px;
  color: #6b7280;
  font-size: 12px;
`

const FinanceMetricCard: React.FC<Props> = ({
  label,
  value,
  tone = 'default',
  subtext,
}) => (
  <Card $tone={tone}>
    <Label>{label}</Label>
    <Value>{value}</Value>
    {subtext && <Subtext>{subtext}</Subtext>}
  </Card>
)

export default FinanceMetricCard
